<template>
  <div class="grid grid-cols-5 gap-12 mb-28" v-if="isLargeScreen">
    <ListItem
      :name="__('page_tree.details')"
      :selected="
        isUserDetailsView ||
        isAmountServiceView ||
        isSelectServiceView ||
        isOverviewView ||
        isPayView
      "
    />
    <ListItem
      :name="__('page_tree.catering')"
      :selected="
        isAmountServiceView ||
        isSelectServiceView ||
        isOverviewView ||
        isPayView
      "
    />
    <ListItem
      :name="__('page_tree.additional_services')"
      :selected="isSelectServiceView || isOverviewView || isPayView"
    />
    <ListItem
      :name="__('page_tree.confirmation')"
      :selected="isOverviewView || isPayView"
    />
    <ListItem :name="__('page_tree.pay')" :selected="isPayView" />
  </div>

  <div class="mb-6" v-else>
    <ListItem
      :name="__('page_tree.details')"
      :selected="isUserDetailsView"
      v-if="isUserDetailsView"
    />
    <ListItem
      :name="__('page_tree.catering')"
      :selected="isAmountServiceView"
      v-if="isAmountServiceView"
    />
    <ListItem
      :name="__('page_tree.additional_services')"
      :selected="isSelectServiceView"
      v-if="isSelectServiceView"
    />
    <ListItem
      :name="__('page_tree.confirmation')"
      :selected="isOverviewView"
      v-if="isOverviewView"
    />
    <ListItem
      :name="__('page_tree.pay')"
      :selected="isPayView"
      v-if="isPayView"
    />
  </div>
</template>

<script>
import { useMediaQuery } from '@vueuse/core'
import {
  isUserDetailsView,
  isAmountServiceView,
  isSelectServiceView,
  isOverviewView,
  isPayView,
} from '@/stores/View'

import ListItem from '@/components/PageTree/ListItem'

export default {
  components: {
    ListItem,
  },
  setup() {
    const isLargeScreen = useMediaQuery('(min-width: 1024px)')

    return {
      isUserDetailsView,
      isAmountServiceView,
      isSelectServiceView,
      isOverviewView,
      isPayView,
      isLargeScreen,
    }
  },
}
</script>
